import * as actionTypes from 'actions';

const initialState = {
  integrationPartnerLoading: false,
  integrationPartner: {
    createdBy: {}
  },
  venues: [],
  venuesLoading: false
};

const integrationPartnerDetailsReducer = (state = initialState, action) => {
  switch (action.type) {
    case actionTypes.FIND_INTEGRATION_PARTNER_PENDING: {
      return {
        ...initialState,
        integrationPartnerLoading: true
      };
    }

    case actionTypes.FIND_INTEGRATION_PARTNER_FULFILLED: {
      return {
        ...state,
        integrationPartnerLoading: false,
        integrationPartner: action.payload.data.result
      };
    }

    case actionTypes.FIND_INTEGRATION_PARTNER_VENUES_PENDING: {
      return {
        ...state,
        venues: initialState.venues,
        venuesLoading: true
      };
    }

    case actionTypes.FIND_INTEGRATION_PARTNER_VENUES_FULFILLED: {
      return {
        ...state,
        venues: action.payload.data.result,
        venuesLoading: false
      };
    }

    default: {
      return state;
    }
  }
};

export default integrationPartnerDetailsReducer;
